module.exports = __webpack_public_path__ + "img/slika50.7343ac16.jpg";